import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { setProfessionalLicenseNumber } from "../../reducer/registrationReducer";
import { setAdditionalInformationModal } from "../../reducer/modalReducer";
import { setFieldCompleted } from "../../reducer/additionalInformationReducer";
import { useCompany } from "../../hooks/useCompany";
import { profile } from "console";

// interface AdditionalInformationModalProps {

// }

function AdditionalInformationModal() {
  const { createCompany } = useCompany();
  const { professionalLicenseNumber } = useSelector(
    (state: RootState) => state.registration
  );
  const dispatch = useDispatch();
  const { additionalInformationModal } = useSelector(
    (state: RootState) => state.modal
  );

  const profile = useSelector((state: RootState) => state.profile.profile);

  // Initialize the license state with the value passed as a prop
  const [editedProfessionalLicenseNumber, setEditedProfessionalLicenseNumber] =
    useState<string>(professionalLicenseNumber);

  // Errors state for validation
  const [errors, setErrors] = useState({
    licenseNumber: "",
  });

  // Update the input value dynamically if the prop changes
  useEffect(() => {
    if (profile) {
      setEditedProfessionalLicenseNumber(
        profile.professionalLicenseNumber || professionalLicenseNumber || ""
      );
    }
    console.log(
      "Updating liscence with initialLicenseNumber:",
      professionalLicenseNumber
    );
  }, [profile, professionalLicenseNumber]);

  // Validation function
  const validateFields = () => {
    const newErrors = {
      licenseNumber: editedProfessionalLicenseNumber
        ? ""
        : "License number is required.",
    };

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  // Handle save changes
  const handleSaveChanges = async () => {
    console.log(
      "Saving changes with license number:",
      professionalLicenseNumber
    );
    if (validateFields()) {
      dispatch(setProfessionalLicenseNumber(editedProfessionalLicenseNumber));
      dispatch(setAdditionalInformationModal(false));
      dispatch(setFieldCompleted(true));
      await createCompany({ setLoading: () => {} });
    }
  };

  // Handle cancel edit
  const handleCancelEdit = () => {
    dispatch(setAdditionalInformationModal(false));
  };

  const handleBackdropClick = (event: any) => {
    if (event.target === event.currentTarget) {
      dispatch(setAdditionalInformationModal(false));
    }
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 w-full h-full items-center justify-center bg-gray-500 bg-opacity-75 ${
        additionalInformationModal ? "flex" : "hidden"
      }`}
      onClick={handleBackdropClick}
    >
      <div className={Classname.modalContent}>
        <div className={Classname.title}>Edit additional information</div>
        <div>Professional licence number</div>
        <input
          type="text"
          value={editedProfessionalLicenseNumber}
          onChange={(e) =>
            dispatch(setProfessionalLicenseNumber(e.target.value))
          }
          className={Classname.input}
        />
        {errors.licenseNumber && (
          <p className="text-red-500">{errors.licenseNumber}</p>
        )}
        <div className={Classname.justifyEnd}>
          <button onClick={handleCancelEdit} className={Classname.button}>
            Cancel
          </button>
          <button onClick={handleSaveChanges} className={Classname.saveButton}>
            Save changes
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdditionalInformationModal;

const Classname = {
  modalContent:
    "bg-white p-6 mx-2 w-full max-w-[500px] rounded shadow-md max-h-[90vh] overflow-scroll",
  title: "font-bold mb-2",
  input: "w-full border border-gray-300 p-2 mt-2 rounded-md h-10",
  button: "px-4 py-2 rounded-lg border-blue-500 border",
  saveButton: "ml-2 bg-blue-500 text-white px-4 py-2 rounded-lg",
  justifyEnd: "mt-4 flex justify-end",
};
